export enum IAppTypes {
  fms = 'fms',
  marketplace = 'marketplace',
}

export interface IUseSavedLaneFormContext {
  /**
   * Used to require fields based on what app is using the form
   * @note Useful for testing different requirements based on app
   */
  app: IAppTypes
}

export enum IDateTypes {
  anyDay = 'anyDay',
  specificDates = 'specificDates',
  daysOfWeek = 'daysOfWeek',
}

export enum IEquipmentTypes {
  anyEquipment = 'anyEquipment',
  dryVan = 'dry_van',
  reefer = 'reefer',
  openDeck = 'open_deck',
}

export enum IRateTypes {
  anyRate = 'anyRate',
  ratePerMile = 'rpm',
  totalAllIn = 'all_in',
}
